import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import { useEffect, useRef, useState } from "react";
import TextInput from "components/form/TextInput";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (code: string) => Promise<void>;
  message?: string;
  isSubmitting?: boolean;
};

export default function OtpConfirmationModal({
  isOpen,
  onClose,
  onSubmit,
  isSubmitting = false,
  message = "Enter the six-digit code from your Authenticator app. Your transaction will submit automatically when the code is complete.",
}: Props) {
  const [code, setCode] = useState("");
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (isOpen) inputRef.current?.focus();
    if (!isOpen) setCode("");
  }, [isOpen]);

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => { if (!isSubmitting) onClose(); }}
      closeOnEsc={!isSubmitting}
      closeOnOverlayClick={!isSubmitting}
      initialFocusRef={inputRef}
      isCentered
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>OTP Code</ModalHeader>
        <ModalCloseButton isDisabled={isSubmitting} />
        <ModalBody>
          <Text mb={4}>
            {message}
          </Text>
          <TextInput
            id="transaction-otp"
            inputRef={inputRef}
            label="Code"
            aria-label="Code"
            name="otp_code"
            inputMode="numeric"
            autoComplete="one-time-code"
            maxLength={6}
            disabled={isSubmitting}
            value={code}
            onChange={(event) => {
              if (isSubmitting) return;
              const nextCode = event.target.value.replace(/\D/g, "").slice(0, 6);
              setCode(nextCode);
              if (nextCode.length === 6) {
                setCode("");
                void onSubmit(nextCode);
              }
            }}
          />
        </ModalBody>
        <ModalFooter>
          <Button onClick={onClose} isDisabled={isSubmitting}>Cancel</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
